export const createFormData = <T extends Record<string, any>>(data: T): FormData => {
  const fd = new FormData();

  const append = (form: FormData, key: string, value: any) => {
    if (value === undefined || value === null) return;

    // Files / Blobs
    if (value instanceof File || value instanceof Blob) {
      form.append(key, value);
      return;
    }

    // Dates
    if (value instanceof Date) {
      form.append(key, value.toISOString());
      return;
    }

    // Arrays
    if (Array.isArray(value)) {
      // Special-case: array of Files -> append same key multiple times
      if (value.every((v) => v instanceof File || v instanceof Blob)) {
        value.forEach((file: File | Blob) => form.append(key, file));
        return;
      }
      // For primitives or objects use indexes
      value.forEach((v, i) => {
        append(form, `${key}[${i}]`, v);
      });
      return;
    }

    // Plain objects
    if (typeof value === 'object') {
      Object.entries(value).forEach(([k, v]) => {
        // ASP.NET Core binder likes dot-notation for nested props
        append(form, `${key}.${k}`, v);
      });
      return;
    }

    // Primitives -> string
    form.append(key, String(value));
  };

  Object.entries(data).forEach(([k, v]) => append(fd, k, v));
  return fd;
};
